import React from 'react';
import classNames from 'classnames';

import styles from './DatePill.module.scss';

export const datePillColors = {
  blue: 'blue',
  success: 'success',
  orange: 'orange',
  purple: 'purple',
  gray: 'gray',
};

export const DatePillComponent = ({
  day,
  month,
  color = datePillColors.blue,
  className,
}) => (
  <div
    className={classNames(
      styles.pill,
      { [styles[`pill_color_${color}`]]: color },
      className
    )}
  >
    <span className={styles.day}>{day}</span>
    <span className={styles.month}>{month}</span>
  </div>
);

DatePillComponent.displayName = 'DatePill';
